<template>
    <div class="payment-congrate">
        <div class="inner">
            <p class="payment-term">Aceptando esta reserva, usted acepta los <a href="#">términos y codiciones</a> y la
                <a href="#">política de cancelación</a> de VolaRooms</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "congratsComponent"
    }
</script>

<style scoped>
    .payment-congrate {
        border: 1px solid #8ac6c4;
        background: #8ac6c4;
    }

    .payment-congrate .btn {
        border: 3px double #8ac6c4;
        color: #8ac6c4
    }
</style>